import React from 'react';
import InfoCard from './InfoCard';
import styles from '../TripTrackingV2.module.scss';

const FIELDS = [
  ['poNo', 'PO No'],
  ['lrNo', 'LR No'],
  ['invoiceNo', 'Invoice No'],
  ['customerName', 'Customer'],
  ['itemName', 'Item(s)'],
];

const ShipmentDetailsCard = ({ trip }) => {
  const rows = FIELDS.filter(([key]) => trip[key]);
  if (!rows.length) return null;

  return (
    <InfoCard title="Shipment details">
      <div className={styles.kvList}>
        {rows.map(([key, label]) => (
          <div className={styles.kvRow} key={key}>
            <span className={styles.kvLabel}>{label}</span>
            <span className={styles.kvValue}>{trip[key]}</span>
          </div>
        ))}
      </div>
    </InfoCard>
  );
};

export default ShipmentDetailsCard;
